import { useAdZoneValuesQuery } from 'data/generated/graphql';

/**
 * Hook to fetch actual AdZone enum values from the backend
 * Returns the actual values stored in the database (e.g., 'businessfinance', 'us', 'technology')
 * rather than the GraphQL enum keys (e.g., 'BUSINESS_FINANCE', 'US', 'TECHNOLOGY')
 */
export const useAdZoneValues = () => {
  const { data, isLoading, error } = useAdZoneValuesQuery();

  return {
    adZoneValues: data?.adZoneValues ?? [],
    loading: isLoading,
    error
  };
};
